const downloadWordFile = (modelClause, language) => {
    const binaryString = window.atob(modelClause.word)
    const binaryLen = binaryString.length
    const bytes = new Uint8Array(binaryLen)
    for (let i = 0; i < binaryLen; i++) {
        const ascii = binaryString.charCodeAt(i)
        bytes[i] = ascii
    }

    const blob = new Blob([bytes], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    const fileName = modelClause[`title_${language}`] + '.docx'
    link.download = fileName
    link.click()
}

export { downloadWordFile }